import type { ScreenBase } from "@frui.ts/screens/dist";
import { ConductorOneChildActive, Router } from "@frui.ts/screens/dist";
import { computed } from "mobx";
import { Modules } from "../../../config";
import LocalizationService from "../../../services/localizationService";
import ExpensesReportsViewModel from "./expensesReportsViewModel";
import RevenuesReportsViewModel from "./revenuesReportsViewModel";

const navigationName = "expenses-and-revenues-reports";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [ExpensesReportsViewModel, RevenuesReportsViewModel],
})
export default class ExpensesAndRevenuesReportsViewModel extends ConductorOneChildActive<
  ExpensesReportsViewModel | RevenuesReportsViewModel
> {
  @computed
  get name() {
    return this.translate("name");
  }

  constructor(
    private localizationService: LocalizationService,
    private expensesReportsViewModel: ExpensesReportsViewModel,
    private revenuesReportsViewModel: RevenuesReportsViewModel
  ) {
    super();
    this.navigationName = navigationName;
    this.children.push(this.revenuesReportsViewModel, this.expensesReportsViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  closeChild(child: ScreenBase) {
    return false;
  }

  translate(code: string) {
    return this.localizationService.translateModule(Modules.finance, `expensesAndRevenuesReports.${code}`);
  }
}
